/** Public path for the default Open Graph / Twitter share image (in `public/`). */
export const DEFAULT_OG_IMAGE_PATH = '/og-default.png';

export function getPublicSiteUrl() {
  const env = process.env.REACT_APP_PUBLIC_SITE_URL;
  if (env && typeof env === 'string') {
    return env.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
}

/** Absolute URL for the site-wide default social preview image. */
export function getDefaultOgImageUrl() {
  const siteUrl = getPublicSiteUrl();
  if (!siteUrl) return '';
  return `${siteUrl}${DEFAULT_OG_IMAGE_PATH}`;
}

/** Resolve a path or absolute URL to a full public URL. */
export function toAbsolutePublicUrl(pathOrUrl) {
  if (pathOrUrl == null || typeof pathOrUrl !== 'string') return '';
  const value = pathOrUrl.trim();
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) return value;
  const siteUrl = getPublicSiteUrl();
  if (!siteUrl) return value;
  return `${siteUrl}${value.startsWith('/') ? value : `/${value}`}`;
}
